/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAssets = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zm-2 2H4v16h16zm-8 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm-1 7H8.126A4.007 4.007 0 0 0 11 15.875zm4.874 0H13v2.874A4.007 4.007 0 0 0 15.875 13zM11 8.127A4.007 4.007 0 0 0 8.126 11H11zm2 0V11h2.874a4.007 4.007 0 0 0-2.873-2.874z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAssets as Assets };
